import styled from "styled-components";

export const VouchersSwiperTitleBox = styled.div`
    text-align: center;
    font-size: 1.3rem;
    padding: 5px 4px 10px 4px;
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        display: none;
    }
`;
